'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _last2 = require('lodash/last');

var _last3 = _interopRequireDefault(_last2);

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _isUndefined2 = require('lodash/isUndefined');

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _compact2 = require('lodash/compact');

var _compact3 = _interopRequireDefault(_compact2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

exports.getClientIp = getClientIp;
exports.parseHash = parseHash;
exports.getRoutesParams = getRoutesParams;
exports.getRoutesLastParam = getRoutesLastParam;
exports.getRoutesFirstParam = getRoutesFirstParam;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getClientIp(req) {
  var regexp = /::(.)*:/igm;
  var ips = [(0, _get3.default)(req, ['headers', 'x-forwarded-for']), (0, _get3.default)(req, ['headers', 'x-real-ip']), (0, _get3.default)(req, 'connection.remoteAddress').replace(regexp, ''), (0, _get3.default)(req, 'socket.remoteAddress').replace(regexp, ''), (0, _get3.default)(req, 'connection.socket.remoteAddress')];
  var ip = (0, _compact3.default)(ips)[0] || '0.0.0.0';

  req.visitor.event({
    ec: 'Client IP',
    ea: 'Get',
    el: 'ip = ' + ip + ' (' + ips.toString() + ')'
  }).send();

  return ip;
}

function parseHash(hash) {
  var hashArr = hash.replace(/^#/, '').split(/[&\?]/); // eslint-disable-line no-useless-escape
  var hashObj = {};
  hashArr.forEach(function (val) {
    var keyVal = val.split('=');
    hashObj[keyVal[0]] = decodeURIComponent(keyVal[1]).replace(/\+/igm, ' ');
  });

  return hashObj;
}

function getRoutesParams(_ref) {
  var _ref$routes = _ref.routes,
      routes = _ref$routes === undefined ? [] : _ref$routes,
      name = _ref.name;

  return (0, _map3.default)(routes.filter(function (route) {
    return !(0, _isUndefined3.default)(route[name]);
  }), name);
}

function getRoutesLastParam(_ref2) {
  var _ref2$routes = _ref2.routes,
      routes = _ref2$routes === undefined ? [] : _ref2$routes,
      name = _ref2.name;

  return (0, _last3.default)(getRoutesParams({ routes: routes, name: name }));
}

function getRoutesFirstParam(_ref3) {
  var _ref3$routes = _ref3.routes,
      routes = _ref3$routes === undefined ? [] : _ref3$routes,
      name = _ref3.name;

  return getRoutesParams({ routes: routes, name: name })[0];
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/network.js
// module id = 528
// module chunks = 1